import {Component, computed, inject, input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {Dropdown} from '../../../../components/dropdown/dropdown';
import {TimesheetTypeSelect, TimesheetTypeService} from '../../../../../api';
import {injectQuery} from '@tanstack/angular-query-experimental';
import {lastValueFrom} from 'rxjs';
import {QueryKey} from '../../../../constants/query-key';
import {MultiDropdown} from '../../../../components/multi-dropdown/multi-dropdown';

interface TimesheetTypeOption {
  id: number;
  name: string;
}

@Component({
  selector: 'elcia-timesheet-type-dropdown',
  imports: [Dropdown, TranslatePipe, MultiDropdown],
  templateUrl: './timesheet-type-dropdown.html',
  styleUrl: './timesheet-type-dropdown.scss',
})
export class TimesheetTypeDropdown {
  private readonly timesheetTypeService = inject(TimesheetTypeService);
  public isMulti = input.required<boolean>();

  control = input.required<FormControl>();

  private readonly typesQuery = injectQuery(() => ({
    queryKey: [QueryKey.TIMESHEET_TYPES_SELECT],
    queryFn: () => lastValueFrom(this.timesheetTypeService.getTimesheetTypeSelect()),
  }));

  protected readonly types = computed<TimesheetTypeSelect[]>(() => this.typesQuery.data()?.timesheetTypes ?? []);
}
